import React from "react";
import { Container } from "../theme";
import SEOHead from "../components/shared/SEOHead";

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen body-font bg-surface-bg text-ink" dir="rtl">
      <meta name="robots" content="noindex" />

      <SEOHead
        title="404 - הדף לא נמצא | Touch Event"
        description="הדף שחיפשת לא נמצא באתר Touch Event. ניתן לחזור לדף הבית או ליצור קשר."
        path="/404"
      />

      <main className="flex items-center justify-center min-h-screen py-16 px-4">
        <Container className="text-center max-w-lg mx-auto">
          <p className="text-8xl font-bold mb-4 brand-font text-brand">
            404
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 brand-font">
            הדף לא נמצא
          </h1>
          <p className="text-lg mb-8 text-ink-muted">
            מצטערים, הדף שחיפשת אינו קיים או שהכתובת השתנתה.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="/"
              className="btn-brown inline-block text-center"
            >
              חזרה לדף הבית
            </a>
            <a
              href="/#contact"
              className="inline-block text-center rounded-full px-5 py-3 font-bold border-2 transition-colors border-brand text-brand"
            >
              צרו קשר
            </a>
          </div>
        </Container>
      </main>
    </div>
  );
};

export default NotFoundPage;
